import type {ReposAppPayload} from '@github-ui/code-view-types'
import {useAppPayload} from '@github-ui/react-core/use-app-payload'

export function useReposAppPayload() {
  return useAppPayload<ReposAppPayload>()
}
